// extracted by mini-css-extract-plugin
module.exports = {"shadow":"Message_shadow__2PdWG","webJobsMessage":"Message_webJobsMessage__1oAan"};